export enum SecurityStatus {
  All = 0,
  PendingApproval = 1,
  Approved = 2,
  Rejected = 3,
  Deleted = 4,
  AwaitingReview = 5,
  InformationRequired = 6,
}
